import "antd/dist/reset.css";
import "./styles/theme.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";

import { App as AntApp, ConfigProvider } from "antd";
import ruRU from "antd/locale/ru_RU";
import { StrictMode, useEffect, useMemo } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { setUnauthorizedHandler } from "./api/client";
import { bindNotification, notify } from "./api/notify";
import { routes } from "./routes";
import { useAuth } from "./stores/auth";
import { useSources } from "./stores/sources";
import { antdThemeOf, useTheme } from "./stores/theme";

const router = createBrowserRouter(routes);

setUnauthorizedHandler(() => {
  useAuth.getState().reset();
  useSources.getState().forget();
  if (window.location.pathname === "/login") return;
  notify.warning(
    "Срок входа истёк",
    "Войдите заново, чтобы продолжить работу.",
  );
  const target = window.location.pathname + window.location.search;
  void router.navigate("/login", {
    replace: true,
    state: { redirect: target },
  });
});

function NotifyBridge() {
  const { notification } = AntApp.useApp();

  useEffect(() => {
    bindNotification(notification);
  }, [notification]);

  return null;
}

function Session() {
  const authorized = useAuth((state) => state.authorized);
  const ensureUser = useAuth((state) => state.ensureUser);
  const loadSources = useSources((state) => state.load);

  useEffect(() => {
    if (!authorized) return;
    void ensureUser();
    loadSources().catch(() => null);
  }, [authorized, ensureUser, loadSources]);

  return <RouterProvider router={router} />;
}

function App() {
  const dark = useTheme((state) => state.dark);
  const theme = useMemo(() => antdThemeOf(dark), [dark]);

  return (
    <ConfigProvider locale={ruRU} theme={theme}>
      <AntApp>
        <NotifyBridge />
        <Session />
      </AntApp>
    </ConfigProvider>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
